let _touches = 'ontouchstart' in window;

module.exports = function () {
  return _touches;
};
